// Stopwatch — count-up stopky pre súťaže (v2): štart od 0, Stop → onStop(sekundy)
// a rodič výsledok uloží (add-mode). Beh prežije reload/zavretie appky — štart je
// v localStorage ako timestamp, čas sa dopočítava z Date.now() (žiadny tikajúci stav).
import { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { st } from "../../styles.js";
import { BuzerIcon } from "../../BuzerIcons";
import { fmtDur } from "../../lib/format";

export function Stopwatch({ id, onStop }) {
  const key = "buzer_stopwatch_" + id;
  const [startTime, setStartTime] = useState(() => {
    const v = localStorage.getItem(key);
    return v ? parseInt(v, 10) : null;
  });
  const [now, setNow] = useState(() => Date.now());
  const [full, setFull] = useState(false);
  const [err, setErr] = useState("");  // chyba uloženia sa musí ukázať V overlayi, nie pod ním
  const savingRef = useRef(false);
  useEffect(() => {
    if (!startTime) return;
    const iv = setInterval(() => setNow(Date.now()), 250);
    return () => clearInterval(iv);
  }, [startTime]);

  function start() {
    const t = Date.now();
    localStorage.setItem(key, String(t));
    setNow(t); setErr("");
    setStartTime(t);
    setFull(true);
  }
  function discard() {
    localStorage.removeItem(key);
    setStartTime(null); setFull(false); setErr("");
  }
  async function stopAndSave() {
    if (savingRef.current) return;  // double-tap guard
    const sec = Math.max(1, Math.round((Date.now() - startTime) / 1000));
    // zabudnuté stopky (napr. cez noc) — pýtaj sa, než sa pripočíta obrí čas
    if (sec > 12 * 3600 && !confirm(`Stopky bežali ${fmtDur(sec)}. Naozaj uložiť celý čas?`)) return;
    savingRef.current = true; setErr("");
    try { await onStop(sec); discard(); }
    catch (e) { setErr((e && e.message) || "Nepodarilo sa uložiť. Skús znova."); }
    finally { savingRef.current = false; }
  }

  if (!startTime) {
    // primárne tlačidlo „Spustiť stopky" — rovnaká podoba ako „Spustiť časovač" v detaile návyku
    // (Timer variant="button"); po spustení sa nižšie prepne na sekundárne „Stopky bežia".
    return (
      <button onClick={start} className="bz-btn bz-btn--primary bz-btn--block" title="Spustiť stopky">
        <BuzerIcon name="stopwatch" size={18} color="currentColor" />Spustiť stopky
      </button>
    );
  }
  const elapsed = Math.max(0, Math.floor((now - startTime) / 1000));
  const clock = fmtDur(elapsed);
  return (
    <>
      <button onClick={() => setFull(true)} className="bz-btn bz-btn--secondary bz-btn--block" title="Stopky — otvoriť na celú obrazovku">
        <BuzerIcon name="stopwatch" size={18} color="currentColor" />Stopky bežia · {clock}
      </button>
      {full && createPortal(
        <div style={st.timerFull} onClick={() => setFull(false)}>
          <div style={st.timerFullInner} onClick={(e) => e.stopPropagation()}>
            <div style={{ ...st.timerDigits, fontFamily: "var(--font-mono)", color: "var(--text)" }}>{clock}</div>
            <div style={{ ...st.timerFullHint, display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
              Do toho! Stop uloží výsledok <BuzerIcon name="dumbbell" size={16} color="currentColor" />
            </div>
            {err && <div style={{ ...st.err, marginTop: 12 }}>{err}</div>}
            <div style={{ display: "flex", gap: 10, marginTop: 22, width: "100%", maxWidth: 340 }}>
              <button onClick={() => { if (confirm("Zahodiť meranie bez uloženia?")) discard(); }} style={st.ghostBtn}>Zahodiť</button>
              <button onClick={stopAndSave} style={{ ...st.primaryBtn, flex: 1 }}>Stop a ulož</button>
            </div>
            <button onClick={() => setFull(false)} style={{ ...st.linkBtn, marginTop: 12 }}>Skryť (beží ďalej)</button>
          </div>
        </div>, document.body
      )}
    </>
  );
}
